import React, { useState } from "react";

import './portabilityAbout.css'

function PortabilityAbout() {
  const [disabled, setDisabled] = useState(false);
  const [toggle, setToggle] = useState(1);

  return (
    <div>
      <div className="portability-about--content">
        <a>Saiba mais sobre a portabilidade</a>

        <br />

        <dl>
        <div onClick={() => setToggle(1)}>
          <dt>Condições para realizar a portabilidade</dt>
          <dd className={toggle !== 1 ? "displayNone" : ""}>
            <li>
              Você deve ter ativado seu novo chip com o mesmo CPF cadastrado na
              operadora antiga.
            </li>
          </dd>
          <dd className={toggle !== 1 ? "displayNone" : ""}>
            <li>
              Certifique-se que o número a ser portado esteja ativo e que não
              existem débitos pendentes na operadora antiga.
            </li>
          </dd>
          <dd className={toggle !== 1 ? "displayNone" : ""}>
            <li>
              Após a solicitação da portabilidade o processo sera automático.{" "}
            </li>
          </dd>
        </div>

        <div onClick={() => setToggle(2)}>
          <dt>Em quanto tempo será concluída minha portabilidade?</dt>
          <dd className={toggle !== 2 ? "displayNone" : ""}>
            <li>
              {`O prazo para efetivar a portabilidade é de até 72 horas úteis, e
                  tanto o seu chip quanto o Chip Correios funcionarão
                  normalmente nesse período.`}
            </li>
          </dd>
        </div>

        <div onClick={() => setToggle(3)}>
          <dt>
            Se eu me arrepender, posso fazer o cancelamento da minha
            portabilidade?
          </dt>
          <dd className={toggle !== 3 ? "displayNone" : ""}>
            <li>
              Sim, você pode fazer o cancelamento em até 24 horas após a
              solicitação da portabilidade. Após esse prazo não será mais
              possível fazer o cancelamento.
            </li>
          </dd>
        </div>
        <div onClick={() => setToggle(4)}>
          <dt>Outros canais para solicitar Portabilidade?</dt>
          <dd className={toggle !== 4 ? "displayNone" : ""}>
            <li>
              Se preferir solicite a portabilidade ligando para *288 ou 10543 e
              fale com a central de atendimento.
            </li>
          </dd>
        </div>

        </dl>

      </div>
    </div>
  );
}

export default PortabilityAbout;
